import { render } from "./routerpsb.vue?vue&type=template&id=fc0b10c0"
import script from "./routerpsb.vue?vue&type=script&lang=js"
export * from "./routerpsb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__